import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from '@mui/material';
import { paths } from 'features/routing';
import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CardRow } from 'features/ui';
import useImageSpecifications from 'features/feed-images/api/useImageSpecifications';
import { ImageSpecification } from 'features/feed-images/feed-images-types';
import { areImageSpecsEqual } from 'features/feed-images/components/ImageSpecifications/ImageSpecification.helpers';

const FeedsOverviewImages = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const purposeId = Number(id);

  if (Number.isNaN(purposeId)) {
    throw new Error('Invalid Purpose ID');
  }

  const { data: imageSpecificationsData } = useImageSpecifications(purposeId);

  const { totalImages, uniqueSpecifications, uniqueShotTypes } = useMemo(() => {
    if (!imageSpecificationsData || imageSpecificationsData.length === 0) {
      return {
        totalImages: 0,
        uniqueSpecifications: 0,
        uniqueShotTypes: 0,
      };
    }

    const uniqueSpecificationItems: ImageSpecification[] = [];
    const uniqueShotTypeIds = new Set<number>();

    imageSpecificationsData.forEach((image) => {
      const hasMatchingSpec = uniqueSpecificationItems.some((spec) =>
        areImageSpecsEqual(spec, image)
      );

      if (!hasMatchingSpec) {
        uniqueSpecificationItems.push(image);
      }

      uniqueShotTypeIds.add(image.shotType);
    });

    return {
      totalImages: imageSpecificationsData.length,
      uniqueSpecifications: uniqueSpecificationItems.length,
      uniqueShotTypes: uniqueShotTypeIds.size,
    };
  }, [imageSpecificationsData]);

  return (
    <Card>
      <CardHeader
        title='Images'
        titleTypographyProps={{
          variant: 'h6',
        }}
      />

      <CardContent>
        {totalImages === 0 ? (
          <Typography>No images found</Typography>
        ) : (
          <Stack>
            <Stack spacing={0.5}>
              <CardRow label=' Unique Shot Types: ' value={uniqueShotTypes} />
              <CardRow
                label='Unique Specifications: '
                value={uniqueSpecifications}
              />
              <CardRow label='Total Images: ' value={totalImages} />
            </Stack>

            <Button
              onClick={() => id && navigate(paths.feedDetailsImageSettings(id))}
              size='small'
              sx={{ alignSelf: 'flex-end', mt: 1 }}
              variant='contained'
            >
              View Image Specifications
            </Button>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default FeedsOverviewImages;
